function Promotion() {
    return (
        <section className="promotion">
            <div className="promotion-container">
                <h1>Promotion & Deals</h1>
                <p>
                    Enjoy exclusive offers on our latest renovation packages! Save up to 20% on selected services.
                </p>
                {/*<a href="#learn more" className="promo-link">
                    Learn More
                </a>*/}
            </div>
        </section>
    );
  }
  
  export default Promotion;